/**
 * Cómo nombrar la matriz de impresión en cada tipo de recurso.
 *
 */

/** Un label en blanco vale lo mismo que uno sin configurar. */
const usar = (valor, porDefecto) =>
  typeof valor === 'string' && valor.trim() ? valor.trim() : porDefecto;

/** Textos cuando el tipo de recurso no define uno propio, o no se conoce. */
export const LABELS_MATRIZ_IMPRESION_DEFAULT = Object.freeze({
  total: 'Total de matriz de impresión',
  tiempo: 'Tiempo matriz de impresión',
  merma: 'Merma matriz de impresión',
});

/**
 * Resuelve los tres labels de un tipo de recurso.
 *
 * Se descartan las cadenas vacías o en blanco: un campo que se borró en el ABM tiene que
 * comportarse igual que uno nunca configurado, no dejar la interfaz con un label vacío.
 *
 * @param {object|null|undefined} recursoTipo RecursoTipo con sus campos Label*.
 * @returns {{total: string, tiempo: string, merma: string}}
 */
export function resolverLabelsMatrizImpresion(recursoTipo) {
  return {
    total: usar(recursoTipo?.LabelTotalPolimeros, LABELS_MATRIZ_IMPRESION_DEFAULT.total),
    tiempo: usar(recursoTipo?.LabelTiempoPolimero, LABELS_MATRIZ_IMPRESION_DEFAULT.tiempo),
    merma: usar(recursoTipo?.LabelMermaPolimero, LABELS_MATRIZ_IMPRESION_DEFAULT.merma),
  };
}

/**
 * Le agrega la unidad entre paréntesis, como venían armados los labels de recurso
 * ("Tiempo polímero (min)"). Sin unidad devuelve el label tal cual.
 */
export function conUnidad(label, unidad) {
  return unidad ? `${label} (${unidad})` : label;
}

/**
 * Completa unos labels que ya vienen resueltos del backend (DatosProcesoDTO), donde el
 * frontend no tiene el RecursoTipo a mano.
 *
 * Hace falta porque un resultado de producción guardado antes de que existiera el campo
 * llega sin él: sin este relleno la pantalla mostraría labels vacíos.
 *
 * @param {{total?: string, tiempo?: string, merma?: string}|null|undefined} labels
 * @returns {{total: string, tiempo: string, merma: string}}
 */
export function completarLabelsMatrizImpresion(labels) {
  return {
    total: usar(labels?.total, LABELS_MATRIZ_IMPRESION_DEFAULT.total),
    tiempo: usar(labels?.tiempo, LABELS_MATRIZ_IMPRESION_DEFAULT.tiempo),
    merma: usar(labels?.merma, LABELS_MATRIZ_IMPRESION_DEFAULT.merma),
  };
}
